import From from "./From";
import To from "./To";
import Pos from "./Pos";
import Shipping from "./Shipping";
import Payment from "./Payment";
import Notenum from "./Shipping/Notenum";
import TextArea from "../../../form/TextArea";
import Picking from "./Picking";
import Invoice from "./Invoice";
import Other from "./Other";
import React from "react";
import BoxEditor from "../../BoxEditor";
import Buttons from "./Buttons";
import Discount from "./Discount";
import VatRate from "./VatRate";

export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    return <Editor
        theme="default"
        footer={<Buttons {...componentProps} />}
    >
        {
            props.values.id && <form onSubmit={props.handleSubmit}>
                <div className="row form-row">
                    <From {...componentProps} />
                    <To {...componentProps} />
                    <Pos {...componentProps} />
                    <Shipping {...componentProps} />
                    <Notenum {...componentProps} />
                </div>
                <Invoice {...componentProps} />
                <div className="row form-row">
                    <Payment {...componentProps} />
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextArea {...props.getProps("comment")} name="comment"
                                  value={props.getValue("comment")} label="Megjegyzés"
                                  saveChanges={props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Discount {...componentProps} />
                    </div>
                    <div className="col-md-6">
                        <VatRate {...componentProps} />
                    </div>
                </div>
                <Picking {...componentProps} />
                <Other {...componentProps} />
            </form>
        }
    </Editor>;
}